module.exports = __webpack_public_path__ + "static/media/iconiantoushangsheng.a7ecb0bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/iconiantoushangsheng.png
// module id = 1975
// module chunks = 0